
  /* You may also like — fetch Shopify recommendations + inject */
  (function () {
    var el = document.getElementById('dl-perso-recs');
    if (!el || !el.dataset.url) return;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('.dl-perso__recs');
      if (inner) el.replaceWith(inner);
    }).catch(function () {});
  })();

  /* Recently viewed — localStorage of handles, render the others */
  (function () {
    var KEY = 'dl_recently_viewed';
    var handle = document.querySelector('.dl-perso').dataset.productHandle;
    var cur = document.querySelector('.dl-perso').dataset.currency;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    var others = list.filter(function (h) { return h !== handle; });
    try { localStorage.setItem(KEY, JSON.stringify([handle].concat(others).slice(0, 12))); } catch (e) {}
    var show = others.slice(0, 4);
    var wrap = document.getElementById('dl-perso-recent');
    if (!wrap || show.length === 0) return;
    Promise.all(show.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(Boolean);
      if (!items.length) return;
      var cards = items.map(function (p) {
        var t = (p.title || '').replace(/\x3c/g, '&lt;');
        var raw = p.featured_image || (p.images && p.images[0]) || '';
        var imgTag = '';
        if (raw) {
          if (raw.indexOf('//') === 0) raw = 'https:' + raw;
          var sep = raw.indexOf('?') > -1 ? '&' : '?';
          var w = function (n) { return raw + sep + 'width=' + n; };
          imgTag = '<img src="' + w(600) + '" srcset="' + w(300) + ' 300w, ' + w(450) + ' 450w, ' + w(600) + ' 600w" sizes="(max-width: 749px) 45vw, 23vw" alt="' + t.replace(/"/g, '&quot;') + '" loading="lazy" width="600" height="600">';
        }
        var price = "";
        try { price = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: cur }); } catch (e) { price = (p.price / 100).toFixed(2); }
        return '<a class="dl-perso__related-card" href="' + p.url + '">' +
          imgTag +
          '<div class="dl-perso__related-meta"><p class="dl-perso__related-title">' + t + '</p>' +
          '<span class="dl-perso__related-price">' + price + '</span></div></a>';
      }).join("");
      wrap.innerHTML = '<div class="dl-perso__related"><h2 class="dl-perso__related-head">Recently <em>viewed.</em></h2><div class="dl-perso__related-grid">' + cards + '</div></div>';
    });
  })();

